export function CapitolMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox='0 0 24 24'
      className={className}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
    >
      <path
        d='M16.0205 10.3334L21.6646 4.6908L20.4873 3.5181L13.6639 7.98159L12 0H10.3361V9.27751C10.3361 9.85961 9.86435 10.3334 9.27997 10.3334H0V11.9968L7.98371 13.6624L2.33752 19.3092L3.51904 20.4819L10.3404 16.0184L12.0042 24H13.6681V14.7182C13.6681 14.1361 14.142 13.6624 14.7243 13.6624H24V11.9968L16.0205 10.3334Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default CapitolMark;
